{
  "title": "Mass Heal",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level evocation",
  "level": 9,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A flood of healing energy flows from you into injured creatures around you. You restore up to 700 hit points, divided as you choose among any number of creatures that you can see within range. Creatures healed by this spell are also cured of all diseases and any effect making them blinded or deafened. This spell has no effect on undead or constructs."
  ],
  "spellLists": ["cleric"]
}
